import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import {ModulosFunctions} from "./ModulosFunction";
import { modulosActivos } from "../hub/Modulo";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ResponseMSGraph} from "../graphInterface/GraphInterfaces";

@Injectable()
export class MsalGuard implements CanActivate {

  constructor(private msalService: MsalService, private http: HttpClient, private model: ModulosFunctions) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.msalService.instance.getActiveAccount() == null) {
      return false;
    }else{
      return this.model.checkUrlModuloInterno(route);
    }

    for (var urlModulo in modulosActivos) {
      if (route.url.toString() == modulosActivos[urlModulo].urlName) {

        var selectedModulo = urlModulo;

        return new Promise<boolean>((resolve, reject) => {
          this.msalService.acquireTokenSilent({
            scopes: ['GroupMember.Read.All']
          }).subscribe(resultado => {

            const httpOptions = {
              headers: new HttpHeaders().set('Authorization', 'Bearer ' + resultado.accessToken)
                .set("Content-type", "application/json")
            }

            let postData = "{\"groupIds\":[\"" + modulosActivos[selectedModulo].id + "\"]}";

            this.http.post("https://graph.microsoft.com/v1.0/me/checkMemberGroups", postData, httpOptions).subscribe(result => {
              var gruposUsuario: ResponseMSGraph = JSON.parse(JSON.stringify(result));
              resolve(gruposUsuario.value.length != 0); // Using resolve here instead of return
            }, error => {
              reject(error);
            });
          }, error => {
            reject(error);
          });
        });
      }
    }

    return false;
  }

}
